// Feature flags configuration
export const ENABLE_INVITATION_PAGE = false; // Set to false to disable the invitation page